import React from 'react';
import {connect} from 'react-redux';
import {addToPrintQueue} from '../actions';
import {bindActionCreators} from 'redux';
import {FormattedMessage} from 'react-intl';
import {printQueue} from '../../../constants/public-routes';
import Link from '../../routing/components/Link';

class AddToPrint extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      feedback: false
    };
  }

  render() {
    let {intl, ids, label, addToPrintqueue, disabled} = this.props;
    let {feedback} = this.state;
    return (<span>
    <span style={{display: disabled ? 'none' : null, cursor: 'pointer'}} onClick={() => {
      this.setState({feedback: true});
      setTimeout(() => {
        this.setState({feedback: false});
      }, 3000);
      addToPrintqueue(intl.locale, ids, label);
    }}>
      <span className="badge">
        <i className="glyphicon glyphicon-print" title={intl.messages.addPrint}/>
        &nbsp;
        <i className="glyphicon glyphicon-plus" title={intl.messages.addPrint}/>
      </span>&nbsp;
    </span>
      <Link url={printQueue(intl.locale)} className={feedback ? 'feedback-show' : 'feedback-hide'}><FormattedMessage id="addedtoPrint"/></Link>
    </span>);
  }
}

AddToPrint.propTypes = {
  intl: React.PropTypes.object,
  addToPrintqueue: React.PropTypes.func,
  ids: React.PropTypes.array.isRequired,
  label: React.PropTypes.string.isRequired,
  disabled: React.PropTypes.bool
};

AddToPrint.defaultProps = {
  disabled: false
};

function mapStateToProps(state) {
  const {intl} = state;
  return {
    intl
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addToPrintqueue: bindActionCreators(addToPrintQueue, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(AddToPrint);



/** WEBPACK FOOTER **
 ** ./src/modules/print/containers/AddToPrint.js
 **/